import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "header-right" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = {
  key: 0,
  class: "custom-tabs"
}
const _hoisted_4 = { class: "tabs-nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tab-title" }
const _hoisted_7 = ["onClick"]

import {reactive, ref, watch} from "vue";
import {useRouter, useRoute} from "vue-router";
import {User} from "@element-plus/icons-vue";
import {useUserStore} from "@/stores/user";
import {ElMessage, ElMessageBox, FormInstance, FormRules} from "element-plus";
import {PwdForm} from "@/types/common";
import {userApi} from "@/api";
import {handleApiError} from "@/utils/error";
import {useKingdeeStore} from "@/stores/kingdeeStroe";
interface MenuItem {
  index: string;
  label: string;
  icon: string;
  path?: string;
  children?: MenuItem[];
}

// 标签页数据接口
interface TabItem {
  path: string;
  title: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const kingdeeStore = useKingdeeStore();
const userStore = useUserStore();

// 菜单数据接口
const router = useRouter();
const route = useRoute();

const menuList: MenuItem[] = [
  {
    index: "1",
    label: "首页",
    icon: "HomeFilled",
    path: "/index/home",
  },
  {
    index: "2",
    label: "财务会计",
    icon: "Edit",
    children: [
      {index: "2-1", label: "出纳管理", icon: "Menu", path: "/index/finc-account/cashier-manage/index"},
    ],
  },
  {
    index: "3",
    label: "供应链",
    icon: "Share",
    children: [
      {index: "3-1", label: "销售管理", icon: "Menu", path: "/index/supply-chain/sales-manage/index"},
      {index: "3-2", label: "采购管理", icon: "Menu", path: "/index/supply-chain/purchases-manage/index"},
    ],
  },
  {
    index: "4",
    label: "基础管理",
    icon: "Postcard",
    children: [
      {index: "4-1", label: "基础资料", icon: "Menu", path: "/index/basic-manage/basic-Information/index"},
    ],
  },
  {
    index: "10",
    label: "系统",
    icon: "Setting",
    children: [
      {index: "10-1", label: "菜单", icon: "Menu", path: "/index/system/index"},
    ],
  },
];

const loading = ref<boolean>(false)
const openNames = ref<string[]>([]);
const activeIndex = ref("1");
const tabList = ref<TabItem[]>([]);
const activeTabPath = ref("");

const isNeedTab = (path: string) => {
  return path.includes('/index/') && path !== '/index/home' && !path.endsWith('/index');
};

const moduleBackUrl = {
  '/index/system/': '/index/system/index',   // 系统模块子项 → 回系统菜单页
  '/index/supply-chain/sales-manage/': '/index/supply-chain/sales-manage/index',   // 业务模块子项 → 回业务菜单页 销售管理
  '/index/finc-account/cashier-manage/': '/index/finc-account/cashier-manage/index',  // 出纳管理
  '/index/supply-chain/purchases-manage/': '/index/supply-chain/purchases-manage/index', // 采购管理
  '/index/basic-manage/basic-Information/': '/index/basic-manage/basic-Information/index' // 基础管理
};

const handleMenuClick = (item: MenuItem) => {
  if (item.path) {
    router.push(item.path);
  }
};

watch(
    () => route.path,
    (newPath) => {
      const findActive = (list: MenuItem[], parentIndex?: string): { activeIndex: string; parentIndex?: string } => {
        for (const item of list) {
          if (item.path === newPath) {
            return { activeIndex: item.index, parentIndex };
          }
          if (item.children && item.children.length > 0) {
            const result = findActive(item.children, item.index);
            if (result.activeIndex) {
              return result;
            }
          }
        }
        return { activeIndex: "" };
      };

      const { activeIndex: idx, parentIndex } = findActive(menuList);
      activeIndex.value = idx;
      if (parentIndex) {
        openNames.value = [parentIndex];
      } else {
        openNames.value = [];
      }

      // 生成标签页
      if (isNeedTab(newPath)) {
        const pageTitle = route.meta.title as string || '未知页面';
        const isTabExist = tabList.value.some(tab => tab.path === newPath);
        if (isTabExist) {
          activeTabPath.value = newPath;
          return;
        }
        tabList.value.push({ path: newPath, title: pageTitle });
        activeTabPath.value = newPath;
      }
    },
    { immediate: true }
);

// 修改密码弹窗相关
const pwdDialogVisible = ref<boolean>(false) // 弹窗显示状态
const currentEditUserId = ref<number>(0) // 当前要修改密码的用户ID
const pwdFormRef = ref<FormInstance>() // 表单引用
// 密码表单数据
const pwdForm = reactive<PwdForm>({
  newPassword: '',
  confirmPassword: ''
})
// 密码表单校验规则
const pwdFormRules = reactive<FormRules>({
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' } // 可根据实际需求调整密码规则
  ],
  confirmPassword: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== pwdForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: 'blur'
    }
  ]
})

// 操作按钮-修改密码
const handleEditPwd = () => {
  // 记录当前要修改密码的用户ID
  currentEditUserId.value = userStore.userInfo.userId;
  // 重置表单
  resetPwdForm();
  // 打开弹窗
  pwdDialogVisible.value = true;
}

// 重置密码表单
const resetPwdForm = () => {
  if (pwdFormRef.value) {
    pwdFormRef.value.resetFields();
  }
  // 清空表单数据
  pwdForm.newPassword = '';
  pwdForm.confirmPassword = '';
}

// 提交修改密码
const submitEditPwd = async () => {
  if (!pwdFormRef.value) return;

  try {
    // 表单校验
    await pwdFormRef.value.validate();
    // 二次确认（可选，增加操作安全性）
    await ElMessageBox.confirm(
        '确定要修改该用户的密码吗？',
        '温馨提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
    );
    loading.value = true;
    // 调用修改密码接口（请根据实际接口调整参数）
    const request = {
      userId:currentEditUserId.value,
      newPassword:pwdForm.newPassword
    }
    await userApi.updateUserPassword(request);
    ElMessage.success('密码修改成功！');
    // 关闭弹窗
    pwdDialogVisible.value = false;
  } catch (error) {
    // 表单校验失败或用户取消操作时不提示错误
    if (error !== 'cancel' && !(error instanceof Error && error.message.includes('Validation failed'))) {
      handleApiError(error);
    }
  } finally {
    loading.value = false;
  }
}

// 标签页切换
const handleTabClick = (tab: any) => {
  router.push(tab.props.name);
};

//关闭标签逻辑
const handleTabClose = (path: string) => {
  const tabIndex = tabList.value.findIndex(tab => tab.path === path);
  tabList.value.splice(tabIndex, 1);

  if (path === activeTabPath.value) {
    const newActiveTab = tabList.value[tabIndex - 1] || tabList.value[0];
    // 如果还有标签，正常切换
    if (newActiveTab) {
      activeTabPath.value = newActiveTab.path;
      router.push(newActiveTab.path);
    } else {
      // 没有标签了 → 动态匹配当前路径所属的模块，回退到对应菜单页
      activeTabPath.value = "";
      let backUrl = "";
      for (const key in moduleBackUrl) {
        if (path.includes(key)) {
          kingdeeStore.clearPageNumber();
          backUrl = moduleBackUrl[key as keyof typeof moduleBackUrl];
          break;
        }
      }
      router.push(backUrl);
    }
  }
};

// 退出登录
const logout = () => {
  userStore.clearToken();
  ElMessage.success("退出登录成功！");
  router.push("/login");
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "header" }, {
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "header-left" }, [
            _createElementVNode("span", { class: "system-name" }, "收银数据集成系统")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_dropdown, null, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: handleEditPwd }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("修改密码")
                      ])),
                      _: 1,
                      __: [4]
                    }),
                    _createVNode(_component_el_dropdown_item, { onClick: logout }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("退出登录")
                      ])),
                      _: 1,
                      __: [5]
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(User))
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(userStore).userInfo?.username || '用户'), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1,
        __: [6]
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_aside, {
            class: "aside",
            style: {"width":"180px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": activeIndex.value,
                "open-names": openNames.value,
                class: "menu",
                "active-text-color": '#fdfeff',
                "background-color": '#4f5d71',
                "text-color": "#fff",
                "unique-opened": ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.index
                    }, [
                      (item.children && item.children.length)
                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 0,
                            index: item.index
                          }, {
                            title: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(item.label), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                  class: "menu_item",
                                  key: child.index,
                                  index: child.index,
                                  onClick: ($event: any) => (handleMenuClick(child))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(child.icon)))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("span", null, _toDisplayString(child.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 1,
                            index: item.index,
                            onClick: ($event: any) => (handleMenuClick(item))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["index", "onClick"]))
                    ], 64))
                  }), 64))
                ]),
                _: 1
              }, 8, ["default-active", "open-names"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, { class: "main" }, {
            default: _withCtx(() => [
              (tabList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (tab) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["tab-item", { active: activeTabPath.value === tab.path }]),
                          key: tab.path,
                          onClick: ($event: any) => (handleTabClick({props:{name:tab.path}}))
                        }, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(tab.title), 1),
                          _createElementVNode("span", {
                            class: "tab-close",
                            onClick: _withModifiers(($event: any) => (handleTabClose(tab.path)), ["stop"])
                          }, "✕", 8, _hoisted_7)
                        ], 10, _hoisted_5))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_view)
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: pwdDialogVisible.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pwdDialogVisible).value = $event)),
            title: "修改用户密码",
            width: "400px",
            onClose: resetPwdForm
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (pwdDialogVisible.value = false))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("取消")
                ])),
                _: 1,
                __: [7]
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitEditPwd
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("确认修改")
                ])),
                _: 1,
                __: [8]
              })
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                ref_key: "pwdFormRef",
                ref: pwdFormRef,
                model: pwdForm,
                rules: pwdFormRules,
                "label-width": "100px",
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "新密码",
                    prop: "newPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: pwdForm.newPassword,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pwdForm.newPassword) = $event)),
                        type: "password",
                        placeholder: "请输入新密码",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "确认新密码",
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: pwdForm.confirmPassword,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pwdForm.confirmPassword) = $event)),
                        type: "password",
                        placeholder: "请再次输入新密码",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, loading.value]
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})